"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styles_1 = require("../../styles");

var createTheme_1 = require("../../styles/theme/createTheme");

var Icons_1 = require("./generated/Icons");

exports.getIconColor = function (theme, color) {
  return !color || color === 'none' ? color : createTheme_1.getTextColor(theme, color);
};

function Icon(props) {
  var style = props.style,
      icon = props.icon,
      fill = props.fill,
      stroke = props.stroke,
      size = props.size,
      rest = __rest(props, ["style", "icon", "fill", "stroke", "size"]);

  var SelectedIcon = Icons_1.IconMap[icon];

  var _a = styles_1.useStyles(function (theme) {
    return {
      icon: {
        fill: fill ? exports.getIconColor(theme, fill) : 'currentColor',
        stroke: stroke && exports.getIconColor(theme, stroke),
        fontSize: size && size + 'rem'
      }
    };
  }),
      classes = _a.classes,
      css = _a.css;

  return react_1.default.createElement(SelectedIcon, __assign({
    role: 'img',
    "aria-hidden": 'true',
    className: css(classes.icon, style)
  }, rest));
}

exports.Icon = Icon;
Icon.defaultProps = {
  size: 1.5
};